// src/modules/demo/translations/demo.translations.ts

const DEMO_TRANSLATIONS = {
  DE: {
    DEMO_BANNER: 'Sie befinden sich im Demo-Modus. Ihre Aenderungen werden nicht gespeichert.',
    SIGNUP_CTA: 'Jetzt registrieren',
    RESET_DEMO: 'Demo zuruecksetzen',
    AVAILABLE_AFTER_SIGNUP: 'Verfuegbar nach Registrierung',
    OBSERVATION: 'Beobachtung',
    OBSERVATION_PLACEHOLDER: 'Beobachtung schreiben...',
    SAVE: 'Speichern',
    CANCEL: 'Abbrechen',
    BACK: 'Zurueck',
    DEMO_BADGE: 'DEMO',
    HOMEWORK: 'Hausaufgabe',
    HOMEWORK_NAME_PLACEHOLDER: 'Aufgabenname...',
    PRESENT: 'Anwesend',
    ABSENT: 'Abwesend',
    DONE: 'Erledigt',
    UNDONE: 'Nicht erledigt',
    NONE: 'Keine',
    TIMELINE: 'Verlauf',
    NO_RECORDS: 'Noch keine Eintraege',
    ATTENDANCE: 'Anwesenheit',
    PARTICIPATION: 'Beteiligung',
    // Conversion toasts
    TOAST_FIRST_ATTENDANCE: 'So schnell geht\'s! In TutoriFy speichert sich alles automatisch.',
    TOAST_FIRST_HOMEWORK: 'Du kannst auch Hausaufgaben tracken.',
    TOAST_FIRST_OBSERVATION: 'Diese Beobachtungen sammeln sich im Schuelerprofil.',
    TOAST_FIRST_TIMELINE: 'So siehst du den Fortschritt jedes Schuelers. Registriere dich, um mit deiner eigenen Klasse zu starten.',
  },
  EN: {
    DEMO_BANNER: "You're in demo mode. Your changes won't be saved.",
    SIGNUP_CTA: 'Sign up now',
    RESET_DEMO: 'Reset demo',
    AVAILABLE_AFTER_SIGNUP: 'Available after signup',
    OBSERVATION: 'Observation',
    OBSERVATION_PLACEHOLDER: 'Write observation...',
    SAVE: 'Save',
    CANCEL: 'Cancel',
    BACK: 'Back',
    DEMO_BADGE: 'DEMO',
    HOMEWORK: 'Homework',
    HOMEWORK_NAME_PLACEHOLDER: 'Task name...',
    PRESENT: 'Present',
    ABSENT: 'Absent',
    DONE: 'Done',
    UNDONE: 'Not done',
    NONE: 'None',
    TIMELINE: 'Timeline',
    NO_RECORDS: 'No records yet',
    ATTENDANCE: 'Attendance',
    PARTICIPATION: 'Participation',
    // Conversion toasts
    TOAST_FIRST_ATTENDANCE: "That's how easy it is! In real TutoriFy, this saves automatically.",
    TOAST_FIRST_HOMEWORK: 'You can track homework too.',
    TOAST_FIRST_OBSERVATION: 'These observations build up in the student\'s profile.',
    TOAST_FIRST_TIMELINE: "This is how you see each student's progress. Sign up to start with your own class.",
  },
} as const;

export type DemoTranslationKey = keyof typeof DEMO_TRANSLATIONS.DE;

export default DEMO_TRANSLATIONS;
